import { render, staticRenderFns } from "./BackupWindowModal.vue?vue&type=template&id=2cffffa6&scoped=true"
import script from "./BackupWindowModal.vue?vue&type=script&lang=js"
export * from "./BackupWindowModal.vue?vue&type=script&lang=js"
import style0 from "./BackupWindowModal.vue?vue&type=style&index=0&id=2cffffa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffffa6",
  null
  
)

export default component.exports